import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Why is the consultation by application?",
    a: "We take on a small number of weddings each year so every couple gets our full attention.",
  },
  {
    q: "What's actually included in the £500 gift?",
    a: "A studio consultation, a private engagement shoot, a framed print, and a glass of champagne. Currently free for the next 24 hours.",
  },
  {
    q: "Where are you based and how far do you travel?",
    a: "Our studio is in Essex. We work across London, Kent, Suffolk and beyond. Destination weddings considered.",
  },
  {
    q: "What if we don't want to book afterwards?",
    a: "No obligation, no pressure, no follow-up. The gift is yours either way.",
  },
  {
    q: "Do you offer film alongside photography?",
    a: "Yes, through our partnership with Wedding Video Essex. Pick the combined collection.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="px-6 md:px-12 lg:px-24 py-20 md:py-28"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10 items-start">
        <div className="md:col-span-4">
          <p className="eyebrow text-muted-foreground mb-6 hidden">Considered Answers</p>
          <h2 className="font-serif-display tracking-tight leading-[0.95] text-3xl sm:text-4xl md:text-5xl">
            Frequently
            <br />
            asked,
            <br />
            <span className="italic">quietly answered.</span>
          </h2>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-border last:border-b py-2"
              >
                <AccordionTrigger className="font-serif-display text-xl md:text-2xl tracking-tight text-left hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-foreground/75 leading-relaxed text-base pb-8 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
